<template>
  <div class="view pa24">
    <el-alert
      title="请先在「短信模板」配置阿里云已审核模板，再勾选客户发送。单次最多 500 人；同一手机号 24 小时内同模板不重复发送。"
      type="info"
      :closable="false"
      class="mb16"
    />

    <div class="filter-bar d-flex flex-wrap-y align-items-center mb16">
      <el-select v-model="customerState" clearable placeholder="客户状态" class="mr12 w140">
        <el-option label="独占客户" :value="1" />
        <el-option label="共享客户" :value="2" />
        <el-option label="成单客户" :value="3" />
        <el-option label="售后客户" :value="5" />
      </el-select>
      <el-input v-model="name" clearable placeholder="电话/姓名/微信" class="mr12 w200" />
      <el-input v-model="followName" clearable placeholder="员工名称" class="mr12 w160" />
      <el-button type="primary" @click="queryClient">查询</el-button>
      <el-button @click="dialogVisible = true">标签筛选</el-button>
      <div class="flex1"></div>
      <span class="mr12 c666">已选 {{ multipleSelection.length }} 人</span>
      <el-button type="primary" :disabled="!multipleSelection.length" @click="openSend(false)">
        发送给已选客户
      </el-button>
      <el-button type="warning" plain @click="openSend(true)">按当前筛选发送</el-button>
    </div>

    <el-table
      :data="tableData"
      v-loading="loading"
      border
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="50" />
      <el-table-column prop="customerId" label="客户ID" width="90" align="center" />
      <el-table-column prop="name" label="姓名" min-width="100" show-overflow-tooltip />
      <el-table-column prop="phone" label="手机号" width="130" show-overflow-tooltip />
      <el-table-column prop="personalWx" label="微信" width="140" show-overflow-tooltip />
      <el-table-column prop="followName" label="跟进人" width="100" show-overflow-tooltip />
      <el-table-column prop="inputDate" label="录入时间" width="170" show-overflow-tooltip />
    </el-table>
    <div class="d-flex justify-content-end mt16">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next"
        :total="total"
        :current-page.sync="pageNum"
        :page-size.sync="pageSize"
        :page-sizes="[10, 20, 50, 100]"
        @current-change="loadData"
        @size-change="loadData"
      />
    </div>

    <labelFiltr
      :visible.sync="dialogVisible"
      @onConfirmTap="onConfirmTap"
      @resetTap="resetTap"
      @updateVisible="updateVisible"
    />

    <el-dialog title="选择模板并发送" :visible.sync="sendVisible" width="560px">
      <el-form label-width="100px">
        <el-form-item label="发送范围">
          <span v-if="sendByFilter">当前筛选条件下全部客户（最多500，仅含有效手机号）</span>
          <span v-else>已勾选 {{ multipleSelection.length }} 人</span>
        </el-form-item>
        <el-form-item label="短信模板" required>
          <el-select v-model="templateId" placeholder="请选择启用中的模板" class="w100p" @change="onTemplateChange">
            <el-option
              v-for="item in templates"
              :key="item.id"
              :label="item.name + ' (' + item.templateCode + ')'"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="任务标题">
          <el-input v-model="title" maxlength="64" placeholder="可选，默认模板名称" />
        </el-form-item>
        <el-form-item
          v-for="key in variableKeys"
          :key="key"
          :label="key"
          :required="key !== 'name'"
        >
          <el-input
            v-model="templateParams[key]"
            :placeholder="key === 'name' ? '可不填，默认取客户姓名' : '请输入变量值'"
          />
        </el-form-item>
        <el-form-item label="文案预览">
          <div class="preview">{{ previewText }}</div>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="sendVisible = false">取消</el-button>
        <el-button type="primary" :loading="sending" @click="confirmSend">确认发送</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getCustomerPC } from "@/api/client";
import { queryEnabledSmsTemplates, createSmsSendTask } from "@/api/sms";
import labelFiltr from "@/pages/customer/components/components/labelFiltr.vue";

export default {
  name: "SmsSend",
  components: { labelFiltr },
  data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      pageNum: 1,
      pageSize: 20,
      customerState: 1,
      name: "",
      followName: "",
      lableIds: [],
      dialogVisible: false,
      multipleSelection: [],
      sendVisible: false,
      sendByFilter: false,
      templates: [],
      templateId: null,
      title: "",
      templateParams: {},
      variableKeys: [],
      contentExample: "",
      sending: false
    };
  },
  computed: {
    previewText() {
      let text = this.contentExample || "";
      const params = { ...this.templateParams };
      if (!params.name) params.name = "张三";
      Object.keys(params).forEach(k => {
        const v = params[k] == null ? "" : params[k];
        text = text.replace(new RegExp("\\$\\{" + k + "\\}", "g"), v);
        text = text.replace(new RegExp("\\{" + k + "\\}", "g"), v);
      });
      return text || "（请选择模板）";
    }
  },
  mounted() {
    this.loadData();
  },
  methods: {
    queryClient() {
      this.pageNum = 1;
      this.loadData();
    },
    loadData() {
      this.loading = true;
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        customerState: this.customerState,
        name: this.name || undefined,
        followName: this.followName || undefined,
        lableIds: this.lableIds && this.lableIds.length ? this.lableIds : undefined
      };
      getCustomerPC(params)
        .then(res => {
          const page = res && res.data && res.data.pageInfo;
          this.tableData = (page && page.list) || [];
          this.total = (page && page.total) || 0;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val || [];
    },
    onConfirmTap(ids) {
      this.lableIds = ids || [];
      this.dialogVisible = false;
      this.queryClient();
    },
    resetTap() {
      this.lableIds = [];
      this.queryClient();
    },
    updateVisible(v) {
      this.dialogVisible = v;
    },
    openSend(byFilter) {
      this.sendByFilter = !!byFilter;
      if (!byFilter && !this.multipleSelection.length) {
        this.$message.warning("请先勾选客户");
        return;
      }
      queryEnabledSmsTemplates({}).then(res => {
        this.templates = (res && res.data) || [];
        if (!this.templates.length) {
          this.$message.warning("请先配置并启用短信模板");
          return;
        }
        this.templateId = this.templates[0].id;
        this.title = "";
        this.onTemplateChange(this.templateId);
        this.sendVisible = true;
      });
    },
    onTemplateChange(id) {
      const tpl = this.templates.find(t => t.id === id);
      if (!tpl) return;
      this.contentExample = tpl.contentExample || "";
      let keys = [];
      try {
        keys = JSON.parse(tpl.variablesJson || "[]") || [];
      } catch (e) {
        keys = String(tpl.variablesJson || "")
          .split(/[,，\s]+/)
          .filter(Boolean);
      }
      this.variableKeys = keys;
      const params = {};
      keys.forEach(k => {
        params[k] = this.templateParams[k] || "";
      });
      this.templateParams = params;
    },
    confirmSend() {
      if (!this.templateId) {
        this.$message.warning("请选择模板");
        return;
      }
      const countTip = this.sendByFilter
        ? "当前筛选条件下的客户"
        : this.multipleSelection.length + " 位已选客户";
      this.$confirm(`确认向${countTip}发送短信？`, "二次确认", { type: "warning" })
        .then(() => {
          this.sending = true;
          const payload = {
            templateId: this.templateId,
            title: this.title,
            templateParams: this.templateParams,
            sendByFilter: this.sendByFilter,
            customerState: this.customerState,
            name: this.name || undefined,
            followName: this.followName || undefined,
            lableIds: this.lableIds && this.lableIds.length ? this.lableIds : undefined
          };
          if (!this.sendByFilter) {
            payload.customerIds = this.multipleSelection.map(i => i.customerId);
          }
          return createSmsSendTask(payload);
        })
        .then(res => {
          const total = (res && res.data && res.data.totalCount) || 0;
          this.$message.success("任务已创建，共 " + total + " 人，可在发送记录中查看进度");
          this.sendVisible = false;
          this.$router.push("/sendSmsRecord");
        })
        .catch(() => {})
        .finally(() => {
          this.sending = false;
        });
    }
  }
};
</script>

<style scoped>
.mb16 {
  margin-bottom: 16px;
}
.mt16 {
  margin-top: 16px;
}
.mr12 {
  margin-right: 12px;
}
.w140 {
  width: 140px;
}
.w160 {
  width: 160px;
}
.w200 {
  width: 200px;
}
.w100p {
  width: 100%;
}
.flex1 {
  flex: 1;
}
.c666 {
  color: #666;
}
.preview {
  background: #f5f7fa;
  border-radius: 4px;
  padding: 10px 12px;
  color: #333;
  line-height: 1.6;
  min-height: 48px;
  white-space: pre-wrap;
}
</style>
